var map = {
	"./1779_JW_Box_1.jpg": 488,
	"./1779_JW_Box_2.jpg": 887,
	"./1785_NR_Candle_Box.jpg": 72,
	"./1793_Unicorn_Miniature_Blanket_Chest.jpg": 532,
	"./Blue_Diamond_Box.jpg": 641,
	"./Blue_Spoon_Rack_1.jpg": 272,
	"./Blue_Spoon_Rack_2.jpg": 671,
	"./Candle_Boxes.jpg": 107,
	"./Early_19th_Century_Somerset_County_Pennsylvania_Box.jpg": 838,
	"./John_Drissel_1795_Funct_Box_1.jpg": 656,
	"./John_Drissel_1795_Funct_Box_2.jpg": 647,
	"./John_Drissel_1799_Hoch_Box.jpg": 530,
	"./Lantern.jpg": 224,
	"./Lehigh_County_PA_Box_1.jpg": 604,
	"./Lehigh_County_PA_Box_2.jpg": 763,
	"./Mary_Burcup_1819_Chest.jpg": 549,
	"./Pipe_Boxes.jpg": 744,
	"./Plate_Rack.jpg": 904,
	"./Red_1823_Small_Blanket_Chest.jpg": 842,
	"./Red_Box.jpg": 379,
	"./Red_Wall_Box.jpg": 312,
	"./Somerset_County_Box_Lid_Detail.jpg": 527,
	"./Spitler_Virginia_Chest.jpg": 547,
	"./Unicorn_Chest_End_Detail.jpg": 242,
	"./Wall_Boxes.jpg": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;